export default __webpack_public_path__ + "static/media/Photo 3 - MR - Couleur sombre.f3b258f8.png";